import React from 'react';
import { ConfirmationModal } from '../common';

const HostSelectStartConfirmModal = ({
  warning,
  loading = false,
  onClose,
  onConfirm,
}) => (
  <ConfirmationModal
    isOpen={Boolean(warning)}
    onClose={onClose}
    onConfirm={onConfirm}
    title="Start this session?"
    message={warning}
    confirmText="Start session"
    cancelText="Cancel"
    loading={loading}
  />
);

export default HostSelectStartConfirmModal;
